import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import FeaturedPartners from "@/components/FeaturedPartners";
import PressOffers from "@/components/PressOffers";
import LocalLife from "@/components/home/LocalLife";

// Bande d'appel à l'action « Demande de devis » (statique, sûre)
function DevisCta() {
  return (
    <div className="rounded-3xl bg-gradient-to-r from-[#E05638] to-[#c94a2f] text-white px-6 py-10 text-center" data-testid="cms-widget-devis-cta">
      <h3 className="font-heading text-2xl md:text-3xl font-extrabold">Besoin d'un pro près de chez vous ?</h3>
      <p className="mt-2 text-white/90 max-w-xl mx-auto">Décrivez votre projet, recevez plusieurs devis gratuits de professionnels locaux en Eure-et-Loir.</p>
      <Link to="/demande-de-devis" className="inline-flex items-center justify-center mt-5 rounded-xl bg-white text-[#E05638] px-6 py-3 font-bold hover:brightness-95 transition" data-testid="cms-widget-devis-btn">
        Demander un devis gratuit
      </Link>
    </div>
  );
}

// Rendu d'un bloc métier. Le code métier reste figé : on réutilise les
// composants existants, l'admin ne peut que les placer (pas les casser).
export default function CmsWidget({ widget }) {
  switch (widget) {
    case "devis_cta":
      return <DevisCta />;
    case "partners_grid":
      return <FeaturedPartners limit={6} testId="cms-widget-partners" />;
    case "offers_grid":
      return <PressOffers limit={8} testId="cms-widget-offers" />;
    case "events":
      return <LocalLife />;
    default:
      return (
        <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 px-4 py-6 text-center text-sm text-slate-400 flex items-center justify-center gap-2" data-testid="cms-widget-unknown">
          <FileText size={16} /> Bloc métier à configurer
        </div>
      );
  }
}
